'use client'

import { FC } from 'react'
import { testIds } from '@/root/shared-consts'
import { useGetTranslations } from '@/root/shared-hooks'
import { DropDownSearch } from '@/root/components/tuuleliinid/DropDownSearch/DropDownSearch'
import RadioInput from './RadioInput'
import type { CustomerType, RoleOption } from '@/root/modules/shared/ConfirmPage'

interface RoleSelectorProps {
  isAuth: boolean
  roleOptions: RoleOption[]
  selectedRole: string
  onRoleChange: (option: RoleOption) => void
  isLoading?: boolean
  customerType: CustomerType
  setCustomerType: (type: CustomerType) => void
}

const RoleSelector: FC<RoleSelectorProps> = ({
  isAuth,
  roleOptions,
  selectedRole,
  onRoleChange,
  isLoading,
  customerType,
  setCustomerType,
}) => {
  const { getTranslation } = useGetTranslations()

  if (isAuth) {
    return (
      <DropDownSearch
        id="role-selector"
        testId={testIds.confirm.selectTicketsUsingAs}
        label={getTranslation('confirmationChooseRole')}
        options={roleOptions}
        selectedValue={selectedRole}
        isLoading={isLoading}
        onChange={onRoleChange}
      />
    )
  }

  return (
    <div className="flex items-start gap-x-10">
      <RadioInput
        label={getTranslation('confirmPagePrivatePersonTab')}
        id="customer-info-private"
        testId={testIds.confirm.selectRolePrivate}
        checked={customerType === 'private'}
        onChange={() => setCustomerType('private')}
      />
      <RadioInput
        label={getTranslation('confirmPageCompanyTab')}
        id="company"
        testId={testIds.confirm.selectRoleCompany}
        checked={customerType === 'company'}
        onChange={() => setCustomerType('company')}
      />
    </div>
  )
}

export default RoleSelector
